export const MOBILE_SCREEN_SIZE = 550

// The only pages a phone gets. The calendar is read-only there whatever the user's role allows.
// The invitations list (and '/', which sends an account without an org to it) is how an invited
// user joins an org, so onboarding can finish on a phone.
export const MOBILE_ROUTES = ['/calendar', '/teamCalendar', '/profile', '/invitationsList']

export const isMobileRoute = (pathname) =>
  pathname === '/' ||
  MOBILE_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`))
